export default "__VITE_ASSET__BRTRhEda__"